var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgNoSearchResultJs = function SvgNoSearchResultJs(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 237,
    fill: "none",
    viewBox: "0 0 299 237",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M140.1 234.2c63.94 0 115.77-51.88 115.77-115.87 0-64-51.83-115.87-115.77-115.87S24.33 54.34 24.33 118.33c0 64 51.83 115.87 115.77 115.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M12.5 104.3h149.85c3.62 0 6.62-3.45-5.87-5.54-16.55-2.76-45.79 6.63-69.2-1.26-5.97-2.02-13.06-9.09-28.49-9.09-25.18 0-26.3 11.14-26.3 11.14s-13.55-6.6-21.6 1.6c-.82.89-1.26 3.14 1.6 3.14Zm279.13 19.87h-94.82c-3.58 0-6.55-1.88 5.8-4.06 16.31-2.9 26.85 6.28 54.12-3.11 20.98-7.24 13.68 2.18 13.68 2.18s7.2-5.94 18.87 1.57c1.19.72 5.22 3.42 2.35 3.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "m250.31 155.28-10.06-5.09-33.89 21.07-14.84-2.39-14.53 3.48-21.84-8.63-43.57 33.94-31.8-8.64-6.28-5.12-34.43-9.84a116.26 116.26 0 0 0 59.24 52.12l54.11-.38 24.36 2.56a116.05 116.05 0 0 0 73.53-73.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m131.26 190.15-17.02-10.83-8.74 5.09-36.2-15.6-26.1 12.25a116.27 116.27 0 0 0 57.32 46l67.9-.1 19.45-20.49-38.9-21.65-17.7 5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m243.8 170.78-32.15-24.48-31.8 25.58-34.05-7.93-36.71 21.14 80.18 30.2 14.7-.04a116.8 116.8 0 0 0 39.82-44.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M171.25 126.76a7.78 7.78 0 0 0-5.63-2.86h-15.59a7.56 7.56 0 0 0-5.56 2.9l-7.37 10.52a7.62 7.62 0 0 1-5.56 2.9h-19.38a8.8 8.8 0 0 0-5.84 2.7l-48 56.93a115.32 115.32 0 0 0 82.23 34.31c32.51 0 61.92-13.41 82.94-35.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M171.25 126.76a7.78 7.78 0 0 0-5.63-2.86h-15.59a7.56 7.56 0 0 0-5.56 2.9l-7.37 10.52a7.62 7.62 0 0 1-5.56 2.9h-19.38a8.8 8.8 0 0 0-5.84 2.7l-48 56.93a115.32 115.32 0 0 0 82.23 34.31c32.51 0 61.92-13.41 82.94-35.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M171.25 126.76a7.78 7.78 0 0 0-5.63-2.86h-15.59a7.56 7.56 0 0 0-5.56 2.9l-7.37 10.52a7.62 7.62 0 0 1-5.56 2.9h-19.38a8.8 8.8 0 0 0-5.84 2.7l-37.87 44.94.58.17c4.16 1.23 8.22 4.44 11.67 7.34l.14.1c3.07 2.56 6.24 5.23 9.86 7.31a45.2 45.2 0 0 0 13.54 5.09c2.63.51 5.4.78 8.16.78 6.2 0 12.52-1.3 18.76-3.82a62.2 62.2 0 0 0 12.39-6.86c2.83-1.98 5.39-4.24 7.91-6.42 1.03-.9 2.09-1.81 3.14-2.7 3.96-3.35 7.34-5.6 10.68-7.1a22.93 22.93 0 0 1 11.8-1.88c3.04.34 5.91 1.36 8.95 2.42a61 61 0 0 0 5.83 1.88c2.53.65 5.02.99 7.37.99 2.8 0 5.5-.48 7.99-1.37a27 27 0 0 0 3.78-1.77l.14-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.04,
    d: "M171.25 126.76a7.78 7.78 0 0 0-5.63-2.86h-15.59a7.56 7.56 0 0 0-5.56 2.9l-7.37 10.52a7.62 7.62 0 0 1-5.56 2.9h-19.38a8.8 8.8 0 0 0-5.84 2.7l-36.88 43.74c4.47 1.34 8.63 4.65 12.18 7.62 3.14 2.63 6.21 5.22 9.8 7.27 4.05 2.32 8.52 4 13.1 4.92 8.76 1.74 17.87.41 26.1-2.97a62.5 62.5 0 0 0 12.11-6.7c3.89-2.73 7.3-6 10.92-9.04 3.38-2.84 7-5.5 11.02-7.31a24.4 24.4 0 0 1 12.56-2.02c5.18.58 9.92 3.04 14.97 4.34 4.81 1.23 9.8 1.37 14.5-.34a21 21 0 0 0 3.55-1.68z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M145.56 125.4c-.82.82-2.01 2.35-2.7 3.31l-4.87 6.9c-.69.95-1.1 1.98-2.63 3.04l-1.98 1.06c-1.13.34-1.47.47-.3.47h7.53a3.9 3.9 0 0 0 3.1-1.87l5.88-11.44a4.2 4.2 0 0 1 3.07-2.05l10.27-.75c1.16-.1 1.16-.17 0-.2l-11.7-.28c-1.16-.04-3 .3-4.1.75z",
    opacity: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.57 222.15c1.02.57 2.25.2 2.76-.86l38.7-79.33c.5-1.06-.04-1.91-1.2-1.91h-9.89l-2.77.17a41 41 0 0 1-3.72-.17c-.88-.1-2.52.07-3.65.37l-2.04.96c-.96.68-2.36 1.95-3.1 2.84L59.67 198.2c-.75.88-.61 2.25.27 3 0 0 4.44 4.95 13.48 11.44 9 6.45 16.14 9.5 16.14 9.5Z",
    opacity: 0.75
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BA85",
    d: "M167.43 105.05a128 128 0 0 1-1.4 8.57l-4.74 1.23s-.38-.52-.17-3.28c.2-2.77.78-7.2 2.63-8.95l3.68 2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BB8B64",
    d: "M163.3 103.17c-1.5 1.98-1.98 5.9-2.18 8.4-.2 2.76.17 3.28.17 3.28l1.4-.38a43.4 43.4 0 0 1 .61-11.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M161.05 113.24s-.54 1.16-.2 3.14c0 0 2.86.79 4.23.38 0 0 .24-.07.48-.75.23-.62.64-2.02.47-2.4 0 0-2.66.76-4.98-.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M162.62 113.75a5.6 5.6 0 0 1-1.57-.5s-.54 1.15-.2 3.13c0 0 .82.24 1.8.38-.06-1.03-.03-2.02-.03-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252A30",
    d: "M160.78 115.87s.14.65 2.49.68c.68 0 2.18.04 2.25-.5 0 0 .3-.35-.03 1.87l-.75 4.5s2.42-.03 2.52 1.54h-6.79c.04-.03-.17-7.95.3-8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BA85",
    d: "M157.3 105.56c-.14 2.05-4.98 17.07-4.98 17.07H150s-.2-7.4 0-10.17 1.8-7.21 3.65-8.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BB8B64",
    d: "M151.2 116.59v-1.4c.03-1.2.16-2.36.37-3.49a56 56 0 0 1 1.3-7.17 18.6 18.6 0 0 0-2.9 8.06c-.21 2.77 0 10.31 0 10.31h1.29a78 78 0 0 1-.07-6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M149.9 114.1s-.59 1.16-.21 3.17c0 0 2.9.79 4.27.38 0 0 1.05-1.2.95-3.15 0-.03-2.66.72-5.01-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M151.12 114.54s.04 0 0 0c-.4-.1-.82-.24-1.22-.45 0 0-.59 1.17-.21 3.18 0 0 .65.17 1.5.3-.07-1.02-.07-2-.07-3.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252A30",
    d: "M149.66 116.8s.13.6 2.52.67c.68 0 2.22.04 2.29-.54 0 0 .4-.04-.2 1.67-.59 1.64-1.24 4.78-1.24 4.78s2.43-.24 2.56 1.57h-6.85s.4-7.99.92-8.16Zm14.6-63.36c-4 .72-9.38 1.98-10.4 4.41-1.03 2.42-2.6 19.9-2.8 23.4-.21 3.48 4.74 2.83 4.74 2.83l7.57-.96 2.5-24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007AA5",
    d: "M160.98 105.28c.9 1.3 5.77 1.34 7-.03s1.36-18.75.92-22.91l-12.7-.76s-1.8.38-2.18 1.64c-1.33 4.82 0 6.63-.82 10.52-1.12 5.33-1.5 9.63-1.33 10 1.68 3.63 6.49 2.64 7.13 1.89.65-.76 2.3-14.28 2.3-14.28l.91-.07c-.1 3.86-1.84 13.08-1.23 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00618C",
    d: "M152.22 104.36c.17-1.02.34-2.08.54-3.1.51-2.57 1.5-4.96 2.01-7.52.55-2.63.58-5.22.75-7.89.1-1.36.17-2.87.52-4.23-.45.1-1.74.54-2.02 1.6-1.33 4.82 0 6.63-.82 10.52-1.12 5.33-1.5 9.63-1.33 10l.34.62Zm7.33-13.79c.55.4 1.77.82 1.77.82l.93-.07c0 .44-.07.92-.1 1.47v.1c-.42 4.33-1.71 11.6-1.17 12.4.24.34.69.57 1.3.74-.48-1.43-.27-3.07-.1-4.64.4-3.76.51-5.98 1.09-9.7.03-.3 1.2-1.09 1.33-2.08-.99 1.02-2.25 1.43-5.05.96m8.19-7.69a17.2 17.2 0 0 0 1.36 5.43 99 99 0 0 0-.2-5.97l-1.43-.07c.13.13.24.34.27.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004772",
    d: "M151.9 102.48a7.4 7.4 0 0 0 0 1.3c1.68 3.62 6.49 2.63 7.14 1.88.14-.17.3-.89.51-1.95-2.08 1.1-5.73.38-7.64-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00618C",
    d: "M156.45 87.66c1.36-1.02 2.21-3.04 2.62-4.64.07-.34.28-.55.48-.68.03-.18.1-.35.14-.52l-3.48-.2s-1.81.37-2.19 1.64a16 16 0 0 0-.61 5.15c1.13.07 2.18-.1 3.04-.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004772",
    d: "M153.61 85.72c.34 0 1.78-1.92 2.08-2.26a24 24 0 0 0 1.47-1.8l-.95-.08s-1.81.38-2.19 1.64c-.27.93-.4 1.74-.5 2.5.06.03.06 0 .1 0Zm7.31 17.41c-.1 1.13-.1 1.92.06 2.15.9 1.3 5.77 1.34 7-.03.24-.27.44-1.13.58-2.36-2.39 1.3-5.7 1.81-7.64.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M169.55 75.92a10.4 10.4 0 0 0 0 6.9s-5.26 4.13-14.47-.45l7.95-27.01 5.19.82 3.85 10.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m162.49 57.2-7.4 25.2c1.56.79 3.03 1.3 4.36 1.64.37-1.88 1.4-3.51 2.56-5.09 1.3-1.77 2.32-3.41 2.83-5.6.92-3.89.48-8.02.2-12.05a15.1 15.1 0 0 0-2.55-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45800",
    d: "M155.15 53.68c.2 2.43-.99 4.51-2.7 4.68-1.7.17-3.27-1.67-3.51-4.1-.2-2.42.99-4.5 2.7-4.67 1.7-.17 3.27 1.67 3.5 4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B25500",
    d: "M155.7 53.68c.13 1.47.75 2.3-.14 2.97-.34.28-2.53 1.23-2.97 1.27-1.53.14-2.9-1.4-3.1-3.45-.18-2.05.85-3.86 2.35-4.17.72-.13 3.51-.75 3.51-.75s.18 2.43.34 4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA3E00",
    d: "M155.7 53.68c-.18-1.74-.35-4.13-.35-4.13s-2.8.62-3.51.75h-.07c2.9.48 3.82 6.56 1.1 7.55 0 .03.06-.03.06-.03a14 14 0 0 0 2.63-1.2c.85-.61.24-1.47.13-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F4200",
    d: "M154.33 56.07a1.9 1.9 0 0 1-1.6.9c-.79-.08-1.95-.76-2.08-2.7-.1-1.71.64-2.67 1.02-2.84.37-.17.55-.17 1.36-.41 1.37.96 1.95 3.48 1.3 5.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D1F00",
    d: "M151.74 52.22c-.24.1-.48.68-.34 2.28.06.9.68 1.85 1.19 1.71.96-.27.27-4.54-.85-4Z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED7100",
    d: "M152.93 58.26c.58-.14 3.38-1.98 7.1-3.42 1.47-.58 10.06-2.97 11.74-3.3 0 0 .71-1.03.3-3.56-.4-2.53-2.08-4.2-2.08-4.2s-14.7 5.02-18.7 5.2c0 0 2.19.5 3.1 2.45.8 1.7.86 3.45.38 4.61-.75 1.84-1.84 2.22-1.84 2.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M155.63 48.19s.03-.17.44-.04c0 0 1.37.51 1.91 3.66.55 3.07-.51 4.16-.51 4.16l-.38.17s1.13-1.09.52-4.47c-.52-2.84-1.98-3.48-1.98-3.48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BA85",
    d: "M148.09 74.38s-1.74 4.37-1.98 10.14l-1 1.88c-.2.48.59 1.06 1.2 1.5.62.45 1.57.58 1.74 0s.62-2.08.34-2.9c-.27-.82 2.4-4.82 3.04-9.5-1.3-.92 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BB8B64",
    d: "M147.75 87.25c-2.32-.17-1.06-3.51-.79-4.74.55-2.57 1.02-5.37 2.08-7.79l-.95-.3s-1.74 4.36-1.98 10.14l-1 1.87c-.2.48.59 1.06 1.2 1.5.62.45 1.57.59 1.74 0 .07-.16.14-.4.2-.71-.13.03-.3.03-.5.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007AA5",
    d: "M163.03 55.4s-8.9 2.14-11.12 5.7a25.35 25.35 0 0 0-3.28 12.12l3.04 1.16s1.7-2.87 2.97-6.25c0 0-.75 4.68-1.13 7.48-.37 2.8-2.11 5.22-4 7.2-1.87 1.98-2.69 4.82-.95 9.12 0 0 .38-3.17 4-6.56 3.61-3.38 7.78-5.8 10.44-9.9 3.58-5.46 4.91-12.26.03-20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00618C",
    d: "M149.55 82.81c-1.8 1.92-2.62 4.58-1.16 8.6-.1-3.3.28-5.18 2.26-8.12 1.46-2.18 3.27-5.36 3.75-8.02.37-2.16.17-4.37.13-6.56-.2 1.33-.75 4.71-1.02 6.9-.34 2.83-2.08 5.22-3.96 7.2m5.25-20.41c2.36-2.77 5.36-4.75 8.54-6.46-.1-.17-.2-.38-.34-.55 0 0-8.9 2.15-11.13 5.7a25.35 25.35 0 0 0-3.27 12.13l1.7.65c-.17-4.03 2.02-8.54 4.5-11.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00618C",
    d: "M163.03 55.4s-.58.13-1.47.4c1.27 4.17.72 8.78-.61 12.91.03.03 2.12-.41 1.98 1.88-.2 4.23-4.5 7.75-12.01 15.02-1.37 1.34-1.7 3.21-1.91 4.99a13.7 13.7 0 0 1 3.61-5.2c3.62-3.37 7.78-5.8 10.44-9.9 3.52-5.5 4.85-12.29-.03-20.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M148.63 72.12s-.71.96-.54 2.26c0 0 2.56 1.2 3.34 1.13 0 0 .78-.72.75-2.02 0 0-1.1-1.13-3.55-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M150.47 72.5a8.2 8.2 0 0 0-1.84-.41s-.71.96-.54 2.25c0 0 .5.24 1.16.52a2.6 2.6 0 0 1 1.22-2.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007AA5",
    d: "M167.91 56.07s7.95 2.8 11.3 7.55c0 0 1.22 2.36 1.05 4.03 0 0-3.79.48-8.12-1.88 0 0-.34 7.45-2.56 10.11 0 0 1.98-6.49.65-12.43-1.33-5.9-2.29-7.1-2.29-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00618C",
    d: "m169.75 75.13 1.03-2.94c.58-1.77.68-3.65.68-5.5 0-.85-.03-1.33.17-2.15.03-.2.4-1.12.48-1.33-.86-.78-1.06-1.7-1.44-2.83-.54-1.64-1.74-3.7-2.73-4.17v.17s.93 1.2 2.29 7.1c1.02 4.72 0 9.77-.48 11.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BA85",
    d: "M182.04 67.24c.68-.78 3.72-6.9.68-12.84 0 0-.04-.89-.2-2.29l-2.77.2s.17 1.48 1.3 2.13c0 0-1.5 4.2-1.44 9.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BB8B64",
    d: "M180.57 61.57c.4-2.32.44-5.02 1.74-7.03.1-.17.24-.31.4-.38-.03-.34-.06-1.06-.2-2.01l-2.76.2s.17 1.47 1.3 2.12c0 0-1.5 4.2-1.44 9.08l.51.79c.14-.96.28-1.85.45-2.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M179.92 63.66s-.3-.24-.72 0c0 0-.27 2.86 1.06 4.03 0 0 1.5.23 1.84-.52 0-.03-.71-2.7-2.18-3.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252A30",
    d: "M154.1 71.75c-.28.14-.62 1.26-.18 1.23.45-.04 4.03-1.37 6.59-5.3 2.56-3.89 1.8-9.83 1.05-11.91 0 0-1.16-.62-2.04.65 0 0 1.43 5.9-.1 9.93a9.9 9.9 0 0 1-5.33 5.4Zm13.7-15.78s.18-.17.45-.17c.89 0 2.73 1.91 3.48 3.9 1.44 3.75 1.78 8.02-.24 10.96 0 0 1.16-3.04-.75-9.22-1.4-4.51-2.93-5.47-2.93-5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M162.76 55.46s0-.55.48-.72c0 0 1.5 1.68 3.68 2.02 0 0-.48.48-.78.95-.31.48-.31 1.1-.31 1.1s-2.42-1.5-3.07-3.35m4.16 1.3s.99-.28.99-.96l.3.44s.66.72-.3 2.16c0-.04.07-1.37-.99-1.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BA85",
    d: "m167.91 55.97.14-.89s2.38.1 2.7-.85c.26-.82 1.73-6.42-3.15-8.16-4.84-1.74-6.55 2.73-4.4 8.67 0 0 2.25 2.29 3.69 2.02 1.02-.2 1.02-.79 1.02-.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BA85",
    d: "M168.01 55.4a6.6 6.6 0 0 1-2.56-.56c-1.36-.58-2.18-1.6-2.25-3.1-.07-1.6-.13-3.25 0-4.85-1.16 1.53-1.2 4.47.07 7.85 0 0 2.25 2.29 3.69 2.02.98-.17.98-.79.98-.79l.07-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252A30",
    d: "M161.73 49.86s.31 1.95 1.1 3.58c0 0 .2-2.52.75-2.9.58-.37 1.6.41 2.11-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007AA5",
    d: "M161.84 48.01s-2.63 2.22-2.63 3.39c0 1.36 14.02-5.98 13.92-6.46s-1.98-.78-5.29.04c0-.04-3 .71-6 3.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M167.64 43.75c-.62.68-1.44 1.16-2.22 1.67-1.3.85-2.76 1.67-4.3 2.08 0 .69.07 1.16.07 1.16 4.4-.88 7.78-3.92 7.78-3.92s-.51-.52-1.33-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00618C",
    d: "M167.98 43.95c-1.16-.75-3.07-1.67-4.81-.65-1.74 1.03-2.05 3.04-2.05 4.27a19 19 0 0 0 6.86-3.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252A30",
    d: "M168.56 50.63c0-.4-.27-.72-.63-.73s-.66.3-.67.7c-.01.39.27.72.63.73.36 0 .66-.3.67-.7m2.56-1.35c0 .4-.31.72-.65.72s-.62-.35-.62-.76c0-.4.31-.71.65-.71.38 0 .65.34.62.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00618C",
    d: "m186.47 51.05-15.9-1.33a.48.48 0 0 1-.4-.48c0-.24.16-.44.4-.48l15.8-3.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004772",
    d: "m170.78 49.14-.38.1c-.07.04-.17.04-.24.04 0 .24.17.4.41.44l15.9 1.33-.1-4.57c-1.64.3-13.24 2.53-15.6 2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00618C",
    d: "M186.68 51.2c.8-.02 1.4-1.3 1.37-2.87-.04-1.57-.7-2.82-1.5-2.8-.79.01-1.4 1.3-1.37 2.86.04 1.57.7 2.82 1.5 2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252A30",
    d: "M186.78 50.88c-.48 0-1.03-.99-1.06-2.46-.03-1.46.48-2.49.96-2.52.47 0 1.02.99 1.05 2.46.04 1.46-.47 2.49-.95 2.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00618C",
    d: "m183.33 53.96-15.39-2.84c-.23-.03-.4-.27-.4-.51s.2-.48.44-.48l15.52-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004772",
    d: "M167.64 50.34c-.04.07-.1.17-.1.27 0 .24.17.48.4.51l15.4 2.84.13-4.82c-5.29.3-10.58.96-15.83 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00618C",
    d: "M185.18 51.12c-.04 1.68-.79 3-1.6 2.97-.86-.03-1.51-1.4-1.44-3.07.03-1.67.78-3 1.6-2.97.85.07 1.5 1.43 1.44 3.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252A30",
    d: "M183.67 53.75c-.5 0-1.05-1.13-.98-2.7.03-1.57.64-2.66 1.16-2.63.5 0 1.05 1.13.98 2.7-.03 1.57-.64 2.67-1.16 2.63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(400.064 0 0 400.412 131.57 151.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(241.137 0 0 241.346 214.15 101.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#BB9A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B59862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#A29273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9079"
  })))));
};
export { SvgNoSearchResultJs as ReactComponent };
export default __webpack_public_path__ + "static/media/noSearchResultJS.515ada31f2ed5cc325f623a402a4ad29.svg";